import { Component, ViewChild } from '@angular/core'
import {
  Currency,
  Depot,
  File,
  Product,
  ProductMove,
  ProductMovePack,
  PurchaseOrder,
  PurchaseOrderItem,
} from 'depoto-core/src/entities'
import { CoreService, HsApiService, NotificationService } from '../../services'
import { Supplier, Tag } from 'depoto-core/src/entities'
import { ListingItem } from 'depoto-core/src/models'
import { productMovePacksPurchaseOrderColumns } from '../../utils/definitions.util'
import { ActivatedRoute, Router } from '@angular/router'
import { FmtDatePipe } from '../../pipes'
import { roundNum, roundEnovaDown, SchemaUtil, getThumbUrl as imageGetThumbUrl } from '../../utils'
import { BaseListing } from '../_base-listing/base-listing'
import { CheckDataChanges } from '../../services/can-deactivate-guard.service'
import { ModalQrCodeComponent } from '../../components/modal-components/modal-qrcode/modal-qrcode.component'
import { TranslateService } from '@ngx-translate/core'
import { ObjectUtils } from '../../utils/diff.util'

export const SHIPPING_PRICE_CZK = 125.01
export const SHIPPING_PRICE_EUR = 5.12
export const FREE_SHIPPING_THRESHOLD_CZK = 3000
export const FREE_SHIPPING_THRESHOLD_EUR = 125

@Component({
  selector: 'app-product-purchase-order-creation-hs',
  templateUrl: './product-purchase-order-creation-hs.component.html',
  styleUrls: ['./product-purchase-order-creation-hs.component.scss'],
  providers: [FmtDatePipe],
})
export class ProductPurchaseOrderCreationHsComponent extends BaseListing implements CheckDataChanges {
  @ViewChild('modalQr') modalQr: ModalQrCodeComponent
  depots: Depot[] = []
  suppliers: Supplier[] = []
  tags: Tag[] = []
  loading = true
  reloading = false
  currentPage: number
  endPage: number
  totalItems = 0
  items: any
  public isCreationModeEnabled = true
  public isEditModeEnabled = true
  public canEdit = false
  public productList: Array<any> = []
  public nonSellableProducts: Array<any> = []
  purchaseOrderInfo: Partial<PurchaseOrderInfo> = {}
  public purchaseOrder: Partial<PurchaseOrder> | any | undefined
  readonly purchaseOrderId
  priceSum = 0
  priceWithVatSum = 0
  discountsSum = 0
  purchaseCurrencyFromCompany: Currency // there is no way to change this across hs, so it's certain we can use this
  activeTab: 'common' | 'dls' | 'pmps' = 'common'
  hasUnsavedChanges = false
  objectForChangesCheck: string
  freeShippingThreshold = FREE_SHIPPING_THRESHOLD_CZK
  shippingPrice = SHIPPING_PRICE_CZK
  isFetchingUnderMinimum = false
  underMinimumProgress = 0
  underMinimumTotal = 0
  underMinimumLoaded = 0

  productMovePacks: ProductMovePack[] = []
  listingColumns: ListingItem[] = productMovePacksPurchaseOrderColumns
  storageKey: { type: string; key: string }
  sortProp = 'created'
  sortDir = 'desc'

  purchaseOrderDocuments: any[] = []

  constructor(
    protected core: CoreService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly fmtDatePipe: FmtDatePipe,
    private readonly translationService: TranslateService,
    private readonly notificationService: NotificationService,
    private readonly hsApi: HsApiService,
  ) {
    super(core)
    this.purchaseOrderId = +this.route.snapshot.params.id
    const selectedProducts = this.router.getCurrentNavigation()?.extras?.state?.selectedProducts
    this.depots = this.core.lists.depots.filter(depot => {
      return depot.name !== 'all' && this.core.services.user?.user?.depots?.some(d => d.id === depot.id)
    })
    this.suppliers = this.core.lists.suppliers
    this.purchaseOrderInfo.supplier = this.suppliers.find(s => s.externalId === 'henryschein')?.id
    this.tags = this.core.lists.tags.filter(tag => tag.type === 'purchaseOrder')
    this.purchaseCurrencyFromCompany = this.core.services.user.user?.company?.currency
    if (this.purchaseCurrencyFromCompany?.id === 'EUR') {
      this.freeShippingThreshold = FREE_SHIPPING_THRESHOLD_EUR
      this.shippingPrice = SHIPPING_PRICE_EUR
    }
    if (this.purchaseOrderId) {
      this.fetch(this.purchaseOrderId).then(() => (this.objectForChangesCheck = JSON.stringify(this.productList)))
      this.isCreationModeEnabled = false
      this.isEditModeEnabled = false
      this.getStorageKey('productMovePacksPurchaseOrder')
      if (!this.isCreationModeEnabled) {
        this.filter(1)
      }
      this.canEdit = this.core.services.user.hasRole('ROLE_PURCHASE_ORDER_UPDATE')
    } else if (selectedProducts) {
      this.productList.push(...selectedProducts)
      this.purchaseOrderInfo.depot = this.router.getCurrentNavigation().extras.state.depot
      this.loading = false
    } else {
      this.loading = false
    }
    const po = this.core.getPurchaseOrderInProgress()
    if (po?.poInfo) {
      this.purchaseOrderInfo = po.poInfo
      this.productList = po.productList
      this.calcSums()
    }
  }

  hasUnsavedDataChanges(): boolean {
    // if (this.objectForChangesCheck !== JSON.stringify(this.productList)) {
    //   console.log(this.objectForChangesCheck, JSON.stringify(this.productList))
    //   try {
    //     console.log(ObjectUtils.diff(JSON.parse(this.objectForChangesCheck), this.productList)) // todo diff: recalculated prices with discounts
    //   } catch (e) {
    //     console.log('ERROR: objectForChangesCheck parse failed', e)
    //   }
    //   // return true
    // }
    // return false
    // // return this.objectForChangesCheck !== JSON.stringify(this.productList);
    // console.log('objcheck', this.objectForChangesCheck)
    try {
      if (
        (this.objectForChangesCheck?.length > 3 &&
          JSON.parse(this.objectForChangesCheck)?.length !== this.productList?.length) ||
        (!this.objectForChangesCheck && this.productList?.length)
      ) {
        return true
      }
    } catch (e) {
      console.log(e, this.objectForChangesCheck)
    }
    return false
  }

  public async fetch(id: number) {
    this.purchaseOrder = await this.core.services.purchase.getById(id, SchemaUtil.purchaseOrderDetail)
    // this.purchaseOrderDocuments = await this.hsApi.getHsDocuments(9224776) // TODO TEST!!!!
    if (this.purchaseOrder?.externalId?.length) {
      this.purchaseOrderDocuments = await this.hsApi.getHsDocuments(this.purchaseOrder?.externalId)
    }
    this.parseCustomData()
    this.setAdditionalInfo(this.purchaseOrder)
    this.purchaseCurrencyFromCompany = this.core.services.user.user.company.currency
    this.productList = this.purchaseOrder.items.map(value => {
      const purchasePriceWithDiscount = roundEnovaDown(value.purchasePrice * (1 - (value.discount || 0) / 100))
      // already-saved orders must always use the stored vatHs rate, not the current product.vat
      const vat = this.hsApi.resolveVat(value.customData?.vatHs, value.product?.vat)
      const coefficient = this.hsApi.getVatHsCoefficient(value.customData?.vatHs, value.product?.vat)
      return (({
        id,
        quantity,
        quantityIn,
        purchasePrice,
        purchasePriceAll,
        currency,
        product,
        note,
        status,
        externalReference,
        discount,
        discounts,
        purchasePriceWithVatAndDiscount,
        purchasePriceAllWithDiscount,
        purchasePriceAllWithVatAndDiscount,
      }) => ({
        id,
        product: product.id,
        quantity,
        quantityIn,
        purchasePrice: roundNum(purchasePrice),
        purchasePriceWithVat: roundNum(purchasePrice / coefficient),
        purchasePriceAll: roundNum(purchasePrice * quantity),
        purchasePriceAllWithVat: roundNum((purchasePrice * quantity) / coefficient),
        currency: this.purchaseCurrencyFromCompany,
        name: product.name,
        fullName: product.fullName,
        mainImage: product.mainImage,
        code: product.code,
        ean: product.ean,
        note,
        externalReference,
        status,
        vat,
        isValid: true,
        tags: product.tags || [],
        packs: product.packs || [],
        quantityAvailable: product.quantityAvailable,
        quantityHs: product.quantityHs,
        discount,
        discounts,
        purchasePriceWithDiscount: purchasePriceWithDiscount,
        purchasePriceWithVatAndDiscount: roundNum(purchasePriceWithDiscount / coefficient),
        purchasePriceAllWithDiscount: roundNum(purchasePriceWithDiscount * quantity),
        purchasePriceAllWithVatAndDiscount: roundNum((purchasePriceWithDiscount * quantity) / coefficient),
        externalId: product.externalId,
        customData: value.customData,
      }))(value)
    })
    // refresh availability per item, then re-pin prices to the saved vatHs.
    // getQuantityHsForProduct() can overwrite customData.vatHs and recompute prices off the
    // *current* HS rate (overrideVatIfZero), so for an already-saved order we restore the stored
    // rate and recompute the with-VAT fields from it. Done sequentially so calcSums() runs last.
    for (const p of this.productList) {
      const savedVatHs = p.customData?.vatHs
      await this.hsApi.getQuantityHsForProduct(p)
      if (savedVatHs !== undefined && savedVatHs !== null) {
        if (!p.customData) {
          p.customData = {}
        }
        p.customData.vatHs = savedVatHs
        p.vat = this.hsApi.resolveVat(savedVatHs, p.vat)
        const coefficient = this.hsApi.getVatHsCoefficient(savedVatHs, p.vat)
        p.purchasePriceWithVat = roundNum(p.purchasePrice / coefficient)
        p.purchasePriceAllWithVat = roundNum((p.purchasePrice * p.quantity) / coefficient)
        p.purchasePriceWithVatAndDiscount = roundNum(p.purchasePriceWithDiscount / coefficient)
        p.purchasePriceAllWithVatAndDiscount = roundNum((p.purchasePriceWithDiscount * p.quantity) / coefficient)
      }
    }
    this.calcSums()
  }

  private setAdditionalInfo(purchaseOrder: PurchaseOrder) {
    if (!purchaseOrder) {
      return
    }
    this.purchaseOrderInfo = (({
      supplier,
      depot,
      tags,
      externalId,
      externalReference,
      note,
      privateNote,
      created,
      createdBy,
      dateEstimatedArrival,
    }) => ({
      supplier: supplier?.id,
      depot: depot?.id,
      note: note,
      privateNote: privateNote,
      dateEstimatedArrival: this.fmtDatePipe.transform(dateEstimatedArrival, 'yyyy-MM-dd'),
      tags: tags?.map(tags => tags.id),
      externalId: externalId,
      externalReference,
      createdBy: createdBy?.name || 'AUTO',
      created: this.fmtDatePipe.transform(created, 'yyyy-MM-dd'),
    }))(purchaseOrder)
  }

  parseCustomData() {
    try {
      this.purchaseOrder.customData = JSON.parse(this.purchaseOrder.customData)
      // this.purchaseOrder.customData.supplierStatus = 'waiting' // todo!!
      // console.log(this.purchaseOrder.customData.supplierStatus)
    } catch (e) {
      console.log('ERROR: customData on purchaseOrder parse failed', e)
    }
    // console.log({order: this.purchaseOrder})
    this.purchaseOrder?.items?.forEach((poi, i) => {
      try {
        this.purchaseOrder.items[i].customData = JSON.parse(poi.customData)
        this.purchaseOrder.items[i].discounts = this.purchaseOrder.items[i].customData.discounts || {}
        this.purchaseOrder.items[i].discount = this.purchaseOrder.items[i].customData.discount || 0
        if (this.purchaseOrder.items[i].discount > 0) {
          // already-saved orders must always use the stored vatHs rate, not the current product.vat
          const coefficient = this.hsApi.getVatHsCoefficient(
            this.purchaseOrder.items[i].customData?.vatHs,
            this.purchaseOrder.items[i].product?.vat,
          )
          const purchasePriceWithoutDiscountRaw = this.purchaseOrder.items[i].customData.purchasePriceWithoutDiscount
          this.purchaseOrder.items[i].purchasePrice =
            purchasePriceWithoutDiscountRaw !== undefined
              ? roundNum(purchasePriceWithoutDiscountRaw)
              : this.purchaseOrder.items[i].purchasePrice || 0

          this.purchaseOrder.items[i].purchasePriceWithVat = roundNum(
            this.purchaseOrder.items[i].purchasePrice / coefficient,
          )

          this.purchaseOrder.items[i].purchasePriceWithDiscount = roundEnovaDown(
            this.purchaseOrder.items[i].purchasePrice * (1 - this.purchaseOrder.items[i].discount / 100),
          )
          this.purchaseOrder.items[i].purchasePriceWithVatAndDiscount = roundNum(
            this.purchaseOrder.items[i].purchasePriceWithDiscount / coefficient,
          )

          this.purchaseOrder.items[i].purchasePriceAllWithDiscount = roundNum(
            this.purchaseOrder.items[i].purchasePriceWithDiscount * this.purchaseOrder.items[i].quantity,
          )
          this.purchaseOrder.items[i].purchasePriceAllWithVatAndDiscount = roundNum(
            this.purchaseOrder.items[i].purchasePriceAllWithDiscount / coefficient,
          )
        }
      } catch (e) {
        console.log(`ERROR: customData on purchaseOrder.items[${i}] parse failed`, e)
      }
    })
  }

  getThumbUrl(image: File): string {
    return imageGetThumbUrl(image)
  }

  async fetchProductsUnderMinimum() {
    const depotId = Number(this.purchaseOrderInfo.depot)
    const supplierId = Number(this.purchaseOrderInfo.supplier)
    if (isNaN(depotId) || depotId < 1 || isNaN(supplierId) || supplierId < 1) {
      alert(this.translationService.instant('depot-and-supplier.select'))
      return
    }
    const params = {
      filters: {
        listType: 'children_and_parents_without_children',
        metrics: 'less_than_minimum',
        metricDepots: [depotId],
        defaultSuppliers: [supplierId],
        enabled: true,
      },
    }
    const allProducts = []
    const productsToAdd = []
    const nonSellableProducts = []
    this.loading = true
    this.isFetchingUnderMinimum = true
    this.underMinimumProgress = 0
    this.underMinimumTotal = 0
    this.underMinimumLoaded = 0
    this.core.services.product
      .getList(params, SchemaUtil.productList)
      .then(result => {
        const endPageNumber = result?.paginator?.endPage || 1
        const promList = []
        for (let i = 1; i <= endPageNumber; i++) {
          promList.push(this.core.services.product.getList({ ...params, page: i }, SchemaUtil.product))
        }
        Promise.all(promList)
          .then(response => {
            response.forEach(row => {
              row.items.forEach(prod => allProducts.push(prod))
            })
          })
          .finally(async () => {
            this.underMinimumTotal = allProducts.length
            this.underMinimumLoaded = 0
            if (this.underMinimumTotal === 0) {
              this.underMinimumProgress = 100
            }
            for (const prod of allProducts) {
              let packQuantity = 1
              if (prod.tags?.find(tag => tag.externalId === 'hs-count-by-piece')) {
                packQuantity = prod.packs?.find(pack => pack.externalId === 'hs-count-by-piece')?.quantity
              }
              const p: any = {
                code: prod.code,
                ean: prod.ean,
                name: prod.name,
                fullName: prod.fullName,
                mainImage: prod.mainImage,
                note: prod.note,
                product: prod.id,
                currency: this.purchaseCurrencyFromCompany,
                purchasePrice: prod.purchasePrice,
                quantity:
                  prod.metrics.find(m => m.depot.id === depotId)?.quantityOptimum -
                  prod.quantities.find(q => q.depot.id === depotId)?.quantityAvailable -
                  prod.metrics.find(m => m.depot.id === depotId)?.quantityPurchase * packQuantity,
                vat: prod.vat,
                externalId: prod.externalId,
                tags: prod.tags,
                packs: prod.packs,
                quantityAvailable: prod.quantities.find(q => q.depot.id === depotId)?.quantityAvailable,
              }
              // console.log('metrics - optimum', prod.metrics.find(m => m.depot.id === depotId)?.quantityOptimum)
              // console.log('metrics - avail', prod.quantities.find(q => q.depot.id === depotId)?.quantityAvailable)
              // console.log('metrics - on the way * packQ', prod.metrics.find(m => m.depot.id === depotId)?.quantityPurchase * packQuantity)
              if (packQuantity > 1) {
                p.quantity = Math.ceil(p.quantity / packQuantity) // always take whole package
              }
              await this.hsApi.getQuantityHsForProduct(p)
              await this.hsApi.getDiscountsForProduct(p)
              if (!p.discounts || p.discounts?.error || !p.discounts?.bestDiscount?.sellable) {
                nonSellableProducts.push(p)
              } else if (p.quantity > 0) {
                productsToAdd.push(p)
              }
              this.underMinimumLoaded++
              this.underMinimumProgress = Math.round((this.underMinimumLoaded / this.underMinimumTotal) * 100)
            }
            this.loading = false
            this.isFetchingUnderMinimum = false
            if (nonSellableProducts?.length) {
              nonSellableProducts.forEach(nsp => {
                if (!this.nonSellableProducts.find(p => p.product === nsp.product)) {
                  this.nonSellableProducts.push(nsp)
                }
              })
            }
            if (!productsToAdd.length) {
              alert(this.translationService.instant('no-products-under-minimum'))
              return
            } else {
              productsToAdd.forEach(async p => {
                if (p.quantity > 0) {
                  await this.addProduct(p, true)
                }
              })
            }
          })
      })
      .catch(() => {
        this.loading = false
        this.isFetchingUnderMinimum = false
      })
  }

  public async addProduct($event: any, isAutomatic?: boolean) {
    const product = (({
      code,
      ean,
      name,
      fullName,
      mainImage,
      note,
      product,
      currency,
      tags,
      packs,
      purchasePrice,
      quantity,
      quantityHs,
      quantityAvailable,
      discount,
      discounts,
      purchasePriceWithDiscount,
      purchasePriceWithVatAndDiscount,
      purchasePriceAllWithDiscount,
      purchasePriceAllWithVatAndDiscount,
      externalId,
      vat,
      customData,
    }) => {
      const pPriceWithDiscount = roundEnovaDown(purchasePrice * (1 - (discount || 0) / 100))
      // const coefficient = this.hsApi.getVatHsCoefficient(
      //   this.purchaseOrder.items[i].customData?.vatHs,
      //   this.purchaseOrder.items[i].product?.vat,
      // )
      return {
        code,
        ean,
        name,
        fullName,
        mainImage,
        note,
        product,
        currency: this.purchaseCurrencyFromCompany,
        tags,
        packs,
        purchasePrice,
        purchasePriceWithVat: roundNum(purchasePrice / (vat?.coefficient || 1)),
        quantity,
        quantityHs,
        purchasePriceAll: roundNum(quantity * purchasePrice),
        purchasePriceAllWithVat: roundNum((quantity * purchasePrice) / (vat?.coefficient || 1)),
        vat,
        isValid: true,
        status: { id: 'new' },
        quantityAvailable,
        discount,
        purchasePriceWithDiscount: pPriceWithDiscount,
        purchasePriceWithVatAndDiscount: roundNum(pPriceWithDiscount / (vat?.coefficient || 1)),
        purchasePriceAllWithDiscount: roundNum(quantity * pPriceWithDiscount),
        purchasePriceAllWithVatAndDiscount: roundNum((quantity * pPriceWithDiscount) / (vat?.coefficient || 1)),
        discounts,
        externalId,
        customData,
      }
    })($event)
    if (product.quantityHs === undefined || product.customData?.vatHs === undefined) {
      await this.hsApi.getQuantityHsForProduct(product)
    }
    if (product.discounts?.bestDiscount === undefined) {
      await this.hsApi.getDiscountsForProduct(product)
    }
    if (product.customData?.vatHs !== undefined) {
      const coef = this.hsApi.getVatHsCoefficient(product.customData.vatHs, product.vat)
      const q = product.quantity
      product.purchasePriceWithVatAndDiscount = roundNum(product.purchasePriceWithDiscount / coef)
      product.purchasePriceAllWithDiscount = roundNum(product.purchasePriceWithDiscount * q)
      product.purchasePriceAllWithVatAndDiscount = roundNum((product.purchasePriceWithDiscount * q) / coef)
    }

    if (
      !isAutomatic &&
      (!product.discounts || product.discounts?.error || !product.discounts?.bestDiscount?.sellable)
    ) {
      // console.log('error fetching discounts', product.discounts)
      this.notificationService.error(this.translationService.instant('purchaseOrder.error.product.notSellable'))
      if (!product.discounts?.bestDiscount?.sellable) {
        this.nonSellableProducts.push(product)
      }
      return
    }
    // handled in fetchProductsUnderMinimum:
    // if (isAutomatic && (!product.discounts || product.discounts?.error || !product.discounts?.bestDiscount?.sellable)) {
    //   // console.log('error fetching discounts on automatic add', product.discounts)
    //   this.nonSellableProducts.push(product)
    //   return
    // }
    if (this.productList.find(p => p.product === product.product)) {
      this.rowChange(product, 'quantity', `${this.productList.find(p => p.product === product.product).quantity + 1}`)
      return
    }
    this.productList.push(product)
    this.calcSums()
  }

  rowChange(item: any, property: 'purchasePrice' | 'purchasePriceWithVat' | 'quantity', nextValue: string | number) {
    if (typeof nextValue === 'number') {
      nextValue = nextValue.toFixed(2)
    }
    if (nextValue.endsWith('.') || nextValue.endsWith(',')) {
      return
    }
    if (nextValue.includes(',')) {
      nextValue = nextValue.replace(',', '.')
    }
    if (isNaN(Number(nextValue))) {
      item.isValid = false
      return
    }
    if (
      property === 'quantity' &&
      (Number(nextValue) < 1 || Number(nextValue) !== Number(Number(nextValue).toFixed(0)))
    ) {
      item.isValid = false
      return
    }
    const nextItem = { ...item }
    switch (property) {
      case 'purchasePrice':
        nextItem.purchasePrice = Number(nextValue)
        nextItem.purchasePriceWithVat = Number(nextValue) / (nextItem.vat?.coefficient || 1)
        nextItem.purchasePriceAll = Number(nextValue) * nextItem.quantity
        nextItem.purchasePriceAllWithVat = (Number(nextValue) / (nextItem.vat?.coefficient || 1)) * nextItem.quantity
        nextItem.purchasePriceWithDiscount = roundEnovaDown(
          nextItem.purchasePrice * (1 - (nextItem.discount || 0) / 100),
        )
        nextItem.purchasePriceAllWithDiscount = nextItem.purchasePriceWithDiscount * nextItem.quantity
        nextItem.purchasePriceAllWithVatAndDiscount =
          (nextItem.purchasePriceWithDiscount * nextItem.quantity) / (nextItem.vat?.coefficient || 1)
        break
      case 'purchasePriceWithVat':
        nextItem.purchasePrice = Number(nextValue) * (nextItem.vat?.coefficient || 1)
        nextItem.purchasePriceWithVat = Number(nextValue)
        nextItem.purchasePriceAll = Number(nextValue) * (nextItem.vat?.coefficient || 1) * nextItem.quantity
        nextItem.purchasePriceAllWithVat = Number(nextValue) * nextItem.quantity
        nextItem.purchasePriceWithDiscount = roundEnovaDown(
          nextItem.purchasePrice * (1 - (nextItem.discount || 0) / 100),
        )
        nextItem.purchasePriceAllWithDiscount = nextItem.purchasePriceWithDiscount * nextItem.quantity
        nextItem.purchasePriceAllWithVatAndDiscount =
          (nextItem.purchasePriceWithDiscount * nextItem.quantity) / (nextItem.vat?.coefficient || 1)
        break
      case 'quantity':
        nextItem.quantity = Number(nextValue)
        nextItem.purchasePriceAll = nextItem.purchasePrice * nextItem.quantity
        nextItem.purchasePriceAllWithVat =
          (nextItem.purchasePrice * nextItem.quantity) / (nextItem.vat?.coefficient || 1)
        nextItem.purchasePriceAllWithDiscount = nextItem.purchasePriceWithDiscount * nextItem.quantity
        nextItem.purchasePriceAllWithVatAndDiscount =
          (nextItem.purchasePriceWithDiscount * nextItem.quantity) / (nextItem.vat?.coefficient || 1)
        break
    }
    this.productList.forEach((row, i) => {
      if (row.product === item.product) {
        this.productList[i].purchasePrice = roundNum(nextItem.purchasePrice)
        this.productList[i].purchasePriceWithVat = roundNum(nextItem.purchasePriceWithVat)
        this.productList[i].purchasePriceAll = roundNum(nextItem.purchasePriceAll)
        this.productList[i].purchasePriceAllWithVat = roundNum(nextItem.purchasePriceAllWithVat)
        this.productList[i].purchasePriceAllWithDiscount = roundNum(nextItem.purchasePriceAllWithDiscount)
        this.productList[i].purchasePriceAllWithVatAndDiscount = roundNum(nextItem.purchasePriceAllWithVatAndDiscount)
        this.productList[i].quantity = nextItem.quantity
        this.productList[i].isValid = true
      }
    })
    this.calcSums()
  }

  calcSums() {
    this.discountsSum = 0
    this.priceSum = this.productList
      .map(p => {
        if (p.discount > 0) {
          return p.purchasePriceAllWithDiscount
        } else {
          return p.purchasePriceAll
        }
      })
      .reduce((a, b) => a + b, 0)
    this.priceWithVatSum = this.productList
      .map(p => {
        if (p.discount > 0) {
          this.discountsSum += p.purchasePriceAllWithVat * (p.discount / 100)
          return p.purchasePriceAllWithVatAndDiscount
        } else {
          return p.purchasePriceAllWithVat
        }
      })
      .reduce((a, b) => a + b, 0)
    const isEligibleForFreeShipping =
      this.priceWithVatSum >= this.freeShippingThreshold ||
      (this.purchaseOrder?.id > 0 && !this.purchaseOrder?.createdBy)
    const shippingPrice = this.purchaseCurrencyFromCompany?.id === 'EUR' ? SHIPPING_PRICE_EUR : SHIPPING_PRICE_CZK
    this.shippingPrice = isEligibleForFreeShipping ? 0 : shippingPrice
    this.hasUnsavedChanges = true
  }

  stockUpAction(event) {
    switch (event) {
      case 'stockUp':
        this.stockUp()
        break
      case 'stockUpInMobileApp':
        this.stockUpInMobileApp()
        break
    }
  }

  stockUp(item?: any) {
    const operations = []
    if (item) {
      const amount = item.quantity - item.quantityIn
      operations.push(
        new ProductMove({
          amount,
          product: {
            id: item.product,
            name: item.fullName,
            fullName: item.fullName,
            purchaseCurrency: item.currency,
            mainImage: item.mainImage,
            enabledBatchExpiration: true,
            tags: item.tags,
            packs: item.packs,
          },
          purchasePrice: item.purchasePrice,
          purchaseOrderItem: item,
          supplier: this.purchaseOrderInfo.supplier,
        }),
      )
    } else {
      this.productList.forEach(item => {
        if (item.quantity - item.quantityIn > 0) {
          operations.push(
            new ProductMove({
              amount: item.quantity - item.quantityIn,
              product: {
                id: item.product,
                name: item.fullName,
                fullName: item.fullName,
                purchaseCurrency: item.currency,
                mainImage: item.mainImage,
                enabledBatchExpiration: true,
                tags: item.tags,
                packs: item.packs,
              },
              purchasePrice: item.purchasePrice,
              purchaseOrderItem: item,
              supplier: this.purchaseOrderInfo.supplier,
            }),
          )
        }
      })
    }
    const stockIn = {
      depotTo: this.purchaseOrderInfo.depot,
      purchaseOrderId: this.purchaseOrderId,
      operations,
    }
    this.router.navigate(['stock-batch-in'], { state: { stockIn } })
  }

  async stockUpCancel(item) {
    if (!confirm(this.translationService.instant('cancel.confirm.item'))) {
      return
    }
    const res = await this.core.services.purchase.updatePurchaseOrderItem({ id: item.id, status: 'cancelled' })
    await this.fetch(this.purchaseOrderId)
  }

  async stockUpCancelRest(item) {
    if (!confirm(this.translationService.instant('cancel.confirm.items'))) {
      return
    }
    const res = await this.core.services.purchase.updatePurchaseOrderItem({ id: item.id, quantity: item.quantityIn })
    await this.fetch(this.purchaseOrderId)
  }

  stockUpInMobileApp() {
    this.modalQr.showChildModal(`PO-${this.purchaseOrderId}`)
  }

  export(type: string) {
    this.core.services.download.downloadDocumentAndShowInNewWindow(this.purchaseOrder[type])
  }

  public async continueToCheckout(): Promise<void> {
    this.hasUnsavedChanges = false
    this.isEditModeEnabled = false
    this.objectForChangesCheck = JSON.stringify(this.productList)
    // console.log('to checkout', this.purchaseOrder)
    this.core.setPurchaseOrderInProgress({
      purchaseOrder: this.purchaseOrder,
      po: this.collectInfo(),
      poInfo: this.purchaseOrderInfo,
      productList: this.productList,
    })
    this.router.navigate(['/purchase-order-checkout'])
  }

  public async saveAsDraft(): Promise<void> {
    const po = this.collectInfoForDraft()
    po.customData = JSON.stringify(po.customData)
    po.items.forEach((poi, i) => {
      po.items[i].customData = JSON.stringify(poi.customData)
    })
    // console.log('final stringified: ', { ...po })
    if (this.isCreationModeEnabled) {
      const result = await this.core.services.purchase.create(po, { id: null })
      this.hasUnsavedChanges = false
      this.isEditModeEnabled = false
      this.objectForChangesCheck = JSON.stringify(this.productList)
      this.core.setPurchaseOrderInProgress(null)
      this.router.navigate(['/purchase-order-hs', result.id], {})
      this.notificationService.success(`Naskladňovací objednávka byla úspěšně vytvořena.`)
    } else {
      await this.core.services.purchase.update(po)
      this.notificationService.success(`Naskladňovací objednávka byla úspěšně aktualizována.`)
      await this.fetch(this.purchaseOrder?.id)
      this.hasUnsavedChanges = false
      this.isEditModeEnabled = false
      this.objectForChangesCheck = JSON.stringify(this.productList)
    }
  }

  private collectInfo() {
    const common = {
      supplier: this.purchaseOrderInfo.supplier,
      depot: this.purchaseOrderInfo.depot,
      note: this.purchaseOrderInfo.note,
      externalReference: this.purchaseOrderInfo.externalReference,
      items: this.productList.map(value => {
        return {
          product: value.product,
          quantity: value.quantity,
          purchasePrice: roundNum(value.purchasePrice),
          note: value.note || '',
          currency: this.purchaseCurrencyFromCompany.id,
          externalId: value.externalId || '',
          discount: value.discount,
          discounts: value.discounts,
          customData: <any>{
            vatHs: value.customData?.vatHs,
          },
        }
      }),
    }
    return this.isCreationModeEnabled ? common : { ...common, id: this.purchaseOrderId }
  }

  private collectInfoForDraft() {
    const common = {
      supplier: this.purchaseOrderInfo.supplier,
      depot: this.purchaseOrderInfo.depot,
      note: this.purchaseOrderInfo.note,
      externalReference: this.purchaseOrderInfo.externalReference,
      customData: <any>{
        shippingPrice: this.shippingPrice,
      },
      status: { id: 'draft' },
      items: this.productList.map(value => {
        return {
          product: value.product,
          quantity: value.quantity,
          purchasePrice: roundNum(value.purchasePrice),
          note: value.note || '',
          currency: this.purchaseCurrencyFromCompany.id,
          externalId: value.externalId || '',
          customData: <any>{
            discount: value.discount,
            discounts: value.discounts,
            purchasePriceWithoutDiscount: roundNum(value.purchasePrice),
            purchasePriceWithVatWithoutDiscount: roundNum(value.purchasePriceWithVat),
            vatHs: value.customData?.vatHs,
          },
        }
      }),
    }
    return this.isCreationModeEnabled ? common : { ...common, id: this.purchaseOrderId }
  }

  public async remove(item: PurchaseOrderItem) {
    if (item.id) {
      // if (item.id && this.purchaseOrder.status.id !== 'draft') {
      await this.core.services.purchase
        .deletePurchaseOrderItem(item.id)
        .then(value => {
          this.removeProductFromList(item)
          this.notificationService.success(`Produkt byl úspěšně smazán z naskladňovací objednávky.`)
        })
        .catch(err => this.notificationService.error(`Produkt se nepodařilo smazat z naskladňovací objednávky.`))
    } else {
      this.removeProductFromList(item)
    }
  }

  private removeProductFromList(item: PurchaseOrderItem): void {
    this.productList = this.productList.filter(value => value.product !== item.product)
    this.calcSums()
  }

  public async delete() {
    if (
      confirm(this.translationService.instant('purchaseOrder.confirm.deletion', { number: this.purchaseOrder.number }))
    ) {
      await this.core.services.purchase
        .deletePurchaseOrder(this.purchaseOrderId)
        .then(value => {
          this.notificationService.success(`Naskladňovací objednávka byla úspěšně smazána.`)
        })
        .catch(err => this.notificationService.error(`Naskladňovací objednávku se nepodařilo smazat.`))
      this.hasUnsavedChanges = false
      this.router.navigate(['/purchase-orders'])
    } else {
      return
    }
  }

  filter(pageNo = 1, sortProp: string = this.sortProp, sortDir: string = this.sortDir, concat = false): void {
    this.currentPage = pageNo

    this.loading = true
    if (!concat) this.reloading = true

    this.core.services.productMovePack
      .getList(
        {
          page: pageNo,
          sort: sortProp,
          direction: sortDir,
          filters: {
            type: 'in',
            purchaseOrder: this.purchaseOrderId,
          },
        },
        SchemaUtil.productMovePackList,
      )
      .then(result => {
        this.loading = false
        this.reloading = false
        if (!concat) {
          this.productMovePacks = result?.items || []
        } else {
          result?.items?.forEach(movePack => {
            this.productMovePacks.push(new ProductMovePack(movePack))
          })
        }
        this.totalItems = result?.paginator ? result.paginator.totalCount : 0
        this.endPage = result?.paginator ? result.paginator.endPage : 0
      })
  }

  callAction(event: any): void {
    this[event.action](event.item)
  }

  navigateBack() {
    if (window.history.length > 1) {
      window.history.back()
    } else {
      this.router.navigate(['/purchase-order-fork'])
    }
  }

  isCountByPieces(prod: Product): boolean {
    return prod?.tags?.some(t => t.externalId === 'hs-count-by-piece')
  }

  async showDocument(url: string) {
    // window.open(url, '_blank')
    // todo fix server CORS on POST... TODO fix tohle, adresa jede:::
    // this.hsApi.getHsDocument(url)
    await this.core.services.download.downloadDocumentAndShowInNewWindow(url, false)
  }
}

type PurchaseOrderInfo = {
  supplier: number
  depot: number
  note: string
  privateNote: string
  dateEstimatedArrival: string
  tags: Array<number>
  reference: string
  externalId: string
  externalReference: string
  createdBy: string
  created: string
}
